import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

import { titleText } from 'features/Theme';

export default {
  headerTitle: (theme: Theme): SerializedStyles => css`
    ${titleText(theme)};
    margin-bottom: ${theme.mui.spacing(3)}px;
    text-align: center;
  `,

  body: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  startOver: (theme: Theme): SerializedStyles => css`
    text-transform: uppercase;
  `,
};
